<div class="box equipment-block item-features item-features-right">
    <span class="has-text-right block-actions">
        <button
            type="button"
            data-tc-action="Clic_redirection"
            data-tc-categorie="Sortie_panier"
            data-tc-clic="Modifier_terminal"
            aria-label="Modifier le terminal"
            class="link has-text-secondary is-size-7 button-clear"
            (click)="stopUsingFtth3Clics()"
            [checkoutNavigateTo]="editUrl"
        >
            Modifier
        </button>
        @if (showDeleteButton) {
            <span class="is-invisible">ou</span>
            <button
                type="button"
                data-tc-action="Clic_redirection"
                data-tc-categorie="Sortie_panier"
                data-tc-clic="Supprimer_terminal"
                aria-label="Supprimer le terminal"
                class="link has-text-secondary is-size-7 button-clear"
                (click)="remove()"
            >
                Supprimer
            </button>
        }
    </span>
    <ng-template checkoutEquipmentBlockHost></ng-template>
</div>
